import { gql } from '@apollo/client';

export const ADD_SUBJECT = gql`
  mutation createSubject($input: CreateSubjectInputType!) {
    createSubject(input: $input) {
      id
      name
      cohortId
    }
  }
`;

export const DELETE_SUBJECT = gql`
  mutation deleteSubject($id: String!) {
    deleteSubject(id: $id)
  }
`;

export const UPDATE_SUBJECT = gql`
  mutation updateSubject($id: String!, $input: UpdateSubjectInputType!) {
    updateSubject(id: $id, input: $input) {
      id
      name
      cohortId
    }
  }
`;
